import {Component, ElementRef, OnInit, TemplateRef, ViewChild, HostListener, AfterViewInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {ContactUsService} from "../../../shared/services/contact-us.service";
import {AlertService} from "../../../shared/services/alert.service";
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-cloud-db-cdn',
    templateUrl: './cloud-db-cdn.component.html',
    styleUrls: ['./cloud-db-cdn.component.scss']
})
export class CloudDbCdnComponent implements OnInit, AfterViewInit {

    @ViewChild('contactFormModal') contactFormModal!: TemplateRef<any>;
    @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
    isModalOpen = false;
    contactForm: FormGroup;
    submitted: any = false;
    submitting: any = false;
    successMessage: string;
    selectedIndex= 0

    tabs = [
        {
            title: 'Ensure Optimal Performance with Managed Cloud Services',
            content: {
                img: 'assets/img/landing-new/db-devops-serverless/consult.png',
                detail:'Our managed cloud services help you leverage the full potential of leading public cloud technologies, tailored to your business needs. We specialize in managing your cloud infrastructure across multiple platforms, ensuring optimal performance, security, and scalability.\n',
                list:[
                    `    Amazon Web Services (AWS): AWS offers a range of cloud services, including databases, storage, processing, machine learning, and analytics, with skilled staff managing your environment for cost-effectiveness, performance optimization, and digital transformation speed.`,
                    '  Google Cloud Platform (GCP): GCP offers robust machine learning and data analytics capabilities, enabling companies to innovate and grow through efficient workload management, infrastructure setup, and seamless connection with Google services.',
                    ' Microsoft Azure: Empower your organization with Azure, which offers a versatile cloud environment, supported by various tools and frameworks. Our managed services ensure efficient, secure, and compliant deployment for optimal use of the Azure ecosystem.',
                    'DigitalOcean: DigitalOcean is a powerful tool that simplifies cloud computing needs with excellence, an ideal option for startups and developers. With a focus on speed, scalability, and cost control, we ensure a streamlined approach to deploying and managing applications.',
                    ' Linode: Linode is a reliable cloud platform with excellent performance and affordability, offering server setup, management, and optimization services, ensuring customized environments, strong security protocols, and high availability.',
                    'Others: This is not its, we offer managed services for various cloud platforms. Our flexible approach allows us to customize service to meet business requirements, ensuring optimal support for your cloud journey based on the chosen provider\'s features.'

                ]
            },
        },
        {
            title: 'Database As a Service for Enhanced Data Management',
            content: {
                img: 'assets/img/landing-new/db-devops-serverless/info.png',
                detail:'Volmint offers secure, scalable, and efficient database management services to help you manage critical data with ease. Our expertise spans major cloud platforms, ensuring that your data management solutions are both efficient and reliable.\n',
                list:[
                    '  AWS Database Services: Our team manages AWS database offerings like Amazon RDS, DynamoDB for NoSQL, DocumentDB for document-based applications, and Redis, optimizing performance, cost, and security for business insights.',
                    'Google Cloud Database: Take advantage of comprehensive management of Google Cloud\'s robust database services, including SQL and NoSQL, ensuring high availability, seamless operations, automatic scaling, and robust security features.',
                    'Azure Database Service: Our services ensure optimal performance, reliability, and security of Azure\'s database solutions, including Azure SQL Database and Cosmos DB, through comprehensive management and maintenance, empower businesses.',
                ]
            },
        },
        {
            title: 'Content Delivery Network (CDN) Services To Upgrade User Experience',
            content: {
                img: 'assets/img/landing-new/db-devops-serverless/business.png',
                detail:'Deliver your content faster and more efficiently with Volmint’s content delivery network solutions, designed for businesses of all sizes. Our robust CDN solutions ensure that your website and applications perform at peak efficiency, delivering content quickly and reliably to users across the globe\n',
                list:[
                    'Akamai: Akamai, a leading CDN provider, offers a vast network for rapid content delivery and robust security features, managed to optimize performance and reduce latency.',
                    'Limelight: Limelight\'s CDN offers high-quality video streaming and content delivery, ensuring seamless experiences for audiences on desktop and mobile devices.',
                    'Cloudflare: Cloudflare\'s CDN enhances security and performance, protecting sites and speeding up content delivery, managed by us to improve site performance and ensure reliable global user delivery.',
                    'Amazon CloudFront: CloudFront integrates with AWS services for efficient content delivery, optimizing distribution for low latency and high transfer speeds, enhancing user experience.',
                    ' Fastly: Fastly is a modern application that offers real-time content delivery and instant updates, with our team optimizing setups to enhance performance, security, and reliability.',
                    'Azure and Google CDN: We manage Azure and Google Cloud\'s CDN services, optimizing their robust infrastructures for efficient content delivery and ensuring speed and performance.',
                    'CDN77: CDN77 provides a cost-effective, high-quality video streaming solution, ensuring fast delivery and enhanced digital media experiences through its configuration and management.'
                ]
            },
        },
    ];

    benifits = [
        {
            header: 'Scalability on Demand',
            text: 'Through our public cloud & delivery services, we prioritize business\'s smooth and reliable growth. Whether you are looking to scale up for peak performance or downsize for cost optimization, our solutions provide unmatched flexibility and scalability.'
        },
        {
            header: 'Easy Integration with Existing Systems',
            text: 'We design and deliver systems that are compatible with almost all legacy systems. This ensures a hassle-free transaction and easy integration with your existing system, tailored to provide seamless integration for maximum productivity. '
        },
        {
            header: 'Global Accessibility\n ',
            text: 'Following the current scenarios, we offer robust global accessibility, empowering and leading your teams with easy access from anywhere in the world. Our public cloud services allow your employees to collaborate remotely in real-time and securely.'
        },
        {
            header: 'Future Ready Solution',
            text: 'With the latest and on-demand techniques such as AI, IoT compatibility, and machine learning, we ensure your business stays ahead of the curve. Volmint’s public cloud and delivery platforms are built to embrace tomorrow’s technology today.'
        }
    ];



    service1 = [
        {text: 'AWS'},
        {text: 'GCP'},
        {text: 'Azure'},
        {text: 'DigitalOcean'},
        {text: 'Linode'},
        {text: 'Others'},
    ];
    service2 = [
        {text: 'AWS RDS, DynamoDB DocumentDB, Redis'},
        {text: 'Google Cloud Database'},
        {text: 'Azure Database Service'},
    ];
    service3 = [
        {text: 'Akamai'},
        {text: 'Limelight'},
        {text: 'Cloudflare'},
        {text: 'Amazon CloudFront'},
        {text: 'Fastly'},
        {text: 'Azure and Google CDN'},
        {text: 'CDN77'},
    ];
    modules = [
        {text: 'Admissions Management'},
        {text: 'Attendance Management'},
        {text: 'Fees Management'},
        {text: 'Exams Management'},
        {text: 'Library Management'},
        {text: 'Payroll Management'},
        {text: 'Organized Department'},
        {text: 'Record Management'},
    ];
    features = [
        {icon: 'assets/img/landing-new/argus/monitoring.png', text: 'Server Setup and Configuration'},
        {icon: 'assets/img/landing-new/argus/analytics.png', text: 'Performance Monitoring'},
        {icon: 'assets/img/landing-new/argus/custom.png', text: 'Security Management'},
        {icon: 'assets/img/landing-new/argus/user.png', text: 'Backup and Disaster Recovery'},
        {icon: 'assets/img/landing-new/argus/multi.png', text: 'Updates and Patch Management'},
        {icon: 'assets/img/landing-new/argus/hybrid.png', text: 'Load Balancing'},
        {icon: 'assets/img/landing-new/argus/automated.png', text: 'Scalability'},
        {icon: 'assets/img/landing-new/argus/scalability.png', text: 'Remote Management'},
        {icon: 'assets/img/services/ongoing_support.jpeg', text: 'Resource Allocation'}

    ];
    whyChoose1 = [
        {
            icon: 'fa-solid fa-layer-group',
            header: 'Expertise Across Leading Platforms',
            text: 'We specialize in leveraging the most preferred public cloud computing providers, such as AWS, Linode, DigitalOcean, GCP, and Microsoft Azure. Our customized solutions with advanced cloud services ensure seamless cloud adoption and integration.'
        },
        {
            icon:'fa-solid fa-database',
            header: 'Strong Database Management Services',
            text: 'Our experts help you address workloads for the public cloud, rebuild applications, and initiate migration with minimal risk and cost. The service allows reduced risk mitigation, ensures complete operation and regulatory compliance of your cloud environment.'
        },
        {
            icon: 'fa-solid fa-infinity',
            header: 'End-to-End Support',
            text: 'No matter, if you require a complete suite of services or just a guiding hand to manage critical workloads, we provide agile-proven methodologies, technologies, and comprehensive assistance for your cloud journey from planning to designing, and deployment.'
        },
        {
            icon: 'fa-solid fa-chart-line',
            header: 'Cost Optimization for Scalable Growth',
            text: 'Volmint Technologies is one the few that can manage complex cloud transactions and deliver services with a focus on resources and efficiency. Our cloud strategies are designed to reduce costs without compromising on performance or quality.'
        },
        {
            icon: 'fa-solid fa-shield-halved',
            header: 'Advanced Security and Compliance',
            text: ' User and provider data security is our priority. Our solutions prioritize data security and compliance with industry regulations, ensuring your business meets the highest standards while safeguarding sensitive information.'
        },
    ];
    whyChoose2 = [
        {
            header: 'AWS Database Services',
            text: 'We specialize in managing various AWS database offerings, including Amazon RDS for relational databases, DynamoDB for NoSQL solutions, DocumentDB for document-based applications, and Redis for in-memory caching. Our team ensures that your AWS database environment is optimized for performance, cost, and security, allowing you to focus on leveraging your data for business insights.'
        },
        {
            header: 'Google Cloud Database',
            text: 'Our expertise extends to Google Cloud\'s powerful database services, which include fully managed solutions for both SQL and NoSQL databases. We help you implement and manage databases that align with your application\'s requirements, ensuring high availability, automatic scaling, and robust security features, all while integrating seamlessly with other Google Cloud services.'
        },
        {
            header: 'Azure Database Service',
            text: 'We offer comprehensive management of Azure\'s diverse database solutions, including Azure SQL Database and Cosmos DB. Our services ensure that your Azure database is configured for optimal performance, reliability, and security. We also provide monitoring and maintenance to keep your database running smoothly, empowering your organization to harness the full power of its data.'
        }
    ];
    whyChoose3 = [
        {
            header: 'Akamai',
            text: 'As a leader in the CDN space, Akamai offers a vast network that ensures rapid content delivery and robust security features. We manage your Akamai implementation to optimize performance and enhance security against DDoS attacks, ensuring your content reaches users with minimal latency.'
        },
        {
            header: 'Limelight',
            text: 'Limelight\'s CDN provides high-quality video streaming and content delivery capabilities. Our team specializes in configuring Limelight to maximize your media delivery, ensuring that your audience enjoys seamless experiences, whether on desktop or mobile devices.'
        },
        {
            header: 'Cloudflare',
            text: 'Known for its security and performance enhancements, Cloudflare\'s CDN helps protect your site while speeding up content delivery. We manage Cloudflare\'s services to improve site performance, enhance security features, and ensure that your content is reliably delivered to users worldwide.'
        },
        {
            header: 'Amazon CloudFront',
            text: 'CloudFront integrates seamlessly with other AWS services, offering a scalable and efficient way to deliver content. We ensure that your CloudFront distribution is optimized for low latency and high transfer speeds, improving your users\' experience.'
        },
        {
            header: 'Fastly',
            text: 'Fastly is designed for modern applications, providing real-time content delivery and instant updates. Our team optimizes your Fastly setup to enhance performance, enabling dynamic content delivery while maintaining security and reliability.'
        },
        {
            header: 'Azure and Google CDN',
            text: 'We provide management for Azure and Google Cloud\'s CDN services, allowing you to leverage their robust infrastructures for effective content delivery. Our expertise ensures that your CDN is optimized for both speed and performance.'
        },
        {
            header: 'CDN77',
            text: 'CDN77 offers an affordable and powerful solution for content delivery with a focus on video streaming and high-quality performance. We configure and manage CDN77 to provide fast delivery and enhance your digital media experiences.'
        },
    ];
    offerings = [
        {
            text: 'Holistic Approach'
        },
        {
            text: 'Modular Flexibility'
        },
        {
            text: 'Real-Time Insights'
        },
        {
            text: 'Enhanced Security'
        },
        {
            text: 'Scalability and Adaptability'
        },
    ];

    constructor(
        private router: Router,
        private fb: FormBuilder,
        private contactService: ContactUsService,
        private alertService: AlertService,
        private meta: Meta,
        private title: Title,
    ) {
    }

    ngOnInit(): void {
        this.updateMetaTags()
        this.refresh();
    }

    ngAfterViewInit() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Add the "visible" class when the element enters the viewport
                    entry.target.classList.add('visible');
                } else {
                    // Remove the "visible" class when the element leaves the viewport
                    entry.target.classList.remove('visible');
                }
            });
        });
        // Select all elements with the class "animate-on-scroll"
        const elements = document.querySelectorAll('.animate-on-scroll, .animate-on-scroll-right');

        // Observe each element
        elements.forEach(element => {
            observer.observe(element);
        });
    }

    refresh() {
        this.contactForm = this.fb.group({
            name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            contact: [''],
            subject: ['', Validators.required],
            message: ['', Validators.required]
        });
    }

    openModal() {
        this.isModalOpen = true;
    }

    closeModal() {
        this.isModalOpen = false;
    }

    handleOverlayClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (!target.closest('.modal-dialog')) {
            this.closeModal();
        }
    }


    selectTab(index: number) {
        this.selectedIndex = index;
    }

    prevSlide() {
        this.selectedIndex = (this.selectedIndex - 1 + this.tabs.length) % this.tabs.length;
    }

    nextSlide() {
        this.selectedIndex = (this.selectedIndex + 1) % this.tabs.length;
    }

    submit() {
        this.submitted = true;
        if (!this.contactForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().name) ? this.contactForm.getRawValue().name : '',
                'email': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().email) ? this.contactForm.getRawValue().email : '',
                'contact': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().contact) ? this.contactForm.getRawValue().contact : '',
                'subject': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().subject) ? this.contactForm.getRawValue().subject : '',
                'message': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().message) ? this.contactForm.getRawValue().message : '',
            };
            this.contactService.create(params).subscribe(data => {
                this.successMessage = 'Your form has been submitted successfully!';
                this.submitted = false;
                this.contactForm.patchValue({
                    'name': '',
                    'email': '',
                    'contact': '',
                    'subject': '',
                    'message': ''
                });
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                    if (error['error']['errors'].subject && error['error']['errors'].subject.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].subject[0]);
                        return;
                    }
                    if (error['error']['errors'].message && error['error']['errors'].message.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].message[0]);
                        return;
                    }
                }
            });
        }
    }

    playVideo() {
        const video = this.videoElement.nativeElement;
        const thumbnail = document.getElementById('video-thumbnail');
        if (video) {
            video.classList.remove('d-none');
            video.play();
            if (thumbnail) {
                thumbnail.style.display = 'none';
            }
            const playButton = document.querySelector('.play-button');
            if (playButton) {
                playButton.classList.add('d-none');
            }
        }
    }

    goTo(url) {
        this.router.navigateByUrl(url);
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        const elements = document.querySelectorAll('.animate-on-scroll');
        const scrollPosition = window.innerHeight + window.scrollY;

        elements.forEach((element) => {
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            if (scrollPosition >= elementPosition) {
                element.classList.add('visible'); // Add the visible class when in view
            }
        });

        const elements1 = document.querySelectorAll('.animate-on-scroll-right');
        const scrollPosition1 = window.innerHeight + window.scrollY;
        elements1.forEach((element) => {
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;

            if (scrollPosition1 >= elementPosition) {
                element.classList.add('visible'); // Add the visible class when in view
            }
        });
    }

    updateMetaTags() {
        this.title.setTitle('Best Public Cloud Computing & Database Management Services');
        this.meta.updateTag({
            name: 'description',
            content: 'Improve your digital infrastructure with robust public cloud computing services using AWS, GCP, and Microsoft Azure-like cloud services for optimal performance.'

        });
        this.meta.updateTag({
            name: 'keyword',
            content: 'public cloud computing, database management services, managed cloud services, content delivery network services, public cloud technologies, database as a service, public cloud computing providers, database services company, databases in cloud computing, content delivery network solutions'

        });
    }

}
